/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Renders the chart title inside the amCharts Root (canvas) so PNG export includes it.
 * Call after `Root.new` + `setThemes`, before pushing XYChart / PieChart.
 */
export function prependRootTitleIfAny(
    amChartsCore: any,
    chartRoot: any,
    title: string | null,
    titleFontSizePx = 18
): void {
    const t = typeof title === "string" ? title.trim() : "";
    if (!t) return;

    chartRoot.container.set("layout", chartRoot.verticalLayout);
    chartRoot.container.children.push(
        amChartsCore.Label.new(chartRoot, {
            text: t,
            width: amChartsCore.percent(100),
            textAlign: "center",
            fontSize: titleFontSizePx,
            fontWeight: "700",
            fill: amChartsCore.color("#0f172a"),
            marginTop: 12,
        })
    );
}
